import { cardsData } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">深度解读</h2>
          <p className="text-foreground-600 text-sm md:text-base">深度分析热门话题背后的故事</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsData.map((card) => (
            <article
              key={card.id}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-semibold">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-3">{card.summary}</p>
                <div className="flex items-center justify-between text-xs text-foreground-500 pt-3 border-t border-background-200/50">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-user-line"></i>
                    {card.author}
                  </span>
                  <span>{card.time}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.reads}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}